import React, { useEffect, useState } from "react";
import Modal from "react-bootstrap/Modal";
import {
  IconLink,
  IconMail,
  IconMailForward,
  IconMessageForward,
  IconTrash,
  IconX,
} from "@tabler/icons-react";
import Select from "react-select";
import {
  Button,
  Table,
  Card,
  Col,
  Form,
  Row,
  InputGroup,
  FormText,
  textarea,
  Tab,
  Tabs,
  Spinner,
  ButtonGroup,
  ListGroup,
} from "react-bootstrap";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { useSelector } from "react-redux";
import usePostRequest from "../../../hooks/usePostRequest";
import { API_ENDPOINTS } from "../../../constant/_constant";
import { toast } from "react-toastify";
import { trimTrailingZeros } from "../../../utils/_helpers";

function KOorCustomerEmailDialog({
  pagetitle,
  toName,
  show,
  setShow,
  toEmail,
  RFQID,
  skuData,
  row,
  defaultSubject,
  Quote_No,
  setIsSuccsessModalOpen,
}) {

  const user = useSelector((state) => state.auth.user);

  const defaultContent = `Hope you're doing great!
    Just wanted to drop a quick note to let you know that we've got those quotes you asked for. Check 'em out in the attachment!
    We've made sure they're exactly what you need based on our recent chats. Any questions or tweaks you want to make, just hit me up. Always here to help!
    Thanks for considering Aspetto. Can't wait to work with you!
    Cheers!`;

  const defaultSignature = `
    <p><strong>Thank You</strong><br/>
     <strong>${user?.first_name} ${user?.last_name}</strong><br/>
    Aspetto Quotes & Sales Team<br/>
    <strong>A:</strong> 150 Riverside pkwy. Suite 203. Fredericksburg, VA 22406 USA<br/>
   <strong>E:</strong> ${user?.email}<br/>
    <strong>P:</strong> 540-547-8487<p/>
    <p><strong>DISCLAIMER:</strong> Please do not reply to this email. This is an automatically triggered email and nobody checks its inbox.</p><br/>
    <p><strong>CONFIDENTIALITY NOTICE:</strong> This e-mail and/or any files transmitted are proprietary and intended solely for the use of the individual or entity to whom they are addressed. 
    Dissemination of this email to anyone else is strictly prohibited. If you have reason to believe that you have received this e-mail in error, contact us immediately by returning it to the sender and destroy this email as well as any attached files. 
    Please note that any views or opinions presented in this e-mail are solely those of the author and do not necessarily represent those of Aspetto, Inc. or any of its subsidiaries or affiliates. 
    The recipient should check this e-mail and any attachments for the presence of viruses. Aspetto, Inc. and its subsidiaries accept no liability for any damage caused by any virus transmitted by this e-mail.</p>`;

  const [attachFilesChecked, setAttachFilesChecked] = useState(false);

  const [attachSKUDetailsInTheBody, setAttachSKUDetailsInTheBody] =
    useState(false);
  const [attachments, setAttachments] = useState([]);

  const [selectedTags, setSelectedTags] = useState([]);
  const [allSKUsCost, setAllSKUsCost] = useState("");

  const [emailData, setEmailData] = useState({
    // Email_REQ_ID: "",
    rfq_id: RFQID ? RFQID : "",
    invoice_no: Quote_No ? Quote_No : "",
    from_email: "platform_admin@aspettoinc.com",
    to_email: toEmail ? toEmail : "",
    to_name: toName,
    cc: ["quotesandsales@aspettoinc.com"],
    subject: defaultSubject ? defaultSubject : "",
    body: defaultContent ? defaultContent : "",
    Email_SentBy_Name: user?.firstName + " " + user?.lastName,
    Email_SentBy_Email: user?.email,
    is_attach: attachFilesChecked,
    attachment_names: "",
    is_attach_sku: attachSKUDetailsInTheBody,
    signature: defaultSignature,
    Latest_Email_Date: "",
    sku_data: skuData,
  });

  const handleAttachmentChange = (event) => {
    if (event.target.files && event.target.files.length > 0) {
      const newFiles = Array.from(event.target.files);
      setAttachments((prevAttachments) =>
        prevAttachments ? [...prevAttachments, ...newFiles] : [...newFiles]
      );

      // Join new filenames into a string
      const newFileNames = newFiles.map((file) => file.name).join(" ");
      setEmailData((prevEmailData) => ({
        ...prevEmailData,
        attachment_names: prevEmailData.attachment_names
          ? `${prevEmailData.attachment_names} ${newFileNames}`
          : newFileNames,
      }));
    }
  };
  const removeAttachment = (indexToRemove) => {
    const updatedAttachments = attachments.filter(
      (_, index) => index !== indexToRemove
    );
    setAttachments(updatedAttachments);
  };

  const handleAttachSKUDetailsCheckboxChange = (e) => {
    const isChecked = e.target.checked;
    setAttachSKUDetailsInTheBody(isChecked);
    setEmailData((prevData) => ({
      ...prevData,
      is_attach_sku: isChecked,
    }));
  };

  const handleAttachSKUDetailsInTheEMailBody = async (e) => {
    if (e.target.checked === true) {
      if (Array.isArray(emailData.sku_data)) {
        const totalSKU = emailData.sku_data.reduce(
          (total, current) => total + Number(current.total_price),
          0
        );
        setAllSKUsCost(
          totalSKU.toLocaleString("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
          })
        );
      } else {
        setAllSKUsCost("0.00");
      }
    }
  };

  const onSuccess = (res) => {

     toast.success("Email Sent Successfully!");
    // setIsSuccsessModalOpen({
    //   show: true,
    //   title: "Success",
    //   message: "Email Sent Successfully!",
    //   btntext: "Close",
    // });
    setShow({ show: false });
  };
const onError = (error) => {
        toast.error(error.message);
    };


  const {
    data: EmailUSerData,
    // isLoading,
    postData: fetchEmails,
  } = usePostRequest(API_ENDPOINTS.EMAIL_ALL_USERS);

  const { isLoading: sendLoading, postData: SendKoandCustomerEmail } =
    usePostRequest(API_ENDPOINTS.SEND_EMAIL_KO_CUSTOMER);

  useEffect(() => {
    fetchEmails();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();

    if (attachments.length > 0) {
      attachments.forEach((attachment) => {
        formData.append("attachments", attachment, attachment.name);
      });
    }

    if (Object.keys(emailData).length > 0) {
      Object.entries(emailData).forEach(([key, value]) => {
        const data = typeof value === "object" ? JSON.stringify(value) : value;
        formData.append(key, data);
      });
    }

    for (let [key, value] of formData.entries()) {
      // console.log(key, value);
    }

    SendKoandCustomerEmail(formData, onSuccess, onError);
  };

  return (
    <Modal
      scrollable={true}
      show={show}
      onHide={() => setShow({ show: false })}
      dialogClassName="modal-90w"
      aria-labelledby="example-custom-modal-styling-title"
      size="lg"
    >
      <Modal.Header className="gap-2" closeButton>
        <span className="avatar bg-blue-lt rounded-circle">
          <IconMailForward stroke={1.25} />
        </span>
        <div>
          <Modal.Title>Mail to {pagetitle}</Modal.Title>
          <Card.Subtitle>
            Quote Number: <strong>{Quote_No}</strong>
          </Card.Subtitle>
        </div>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={handleSubmit}>
          <Row className="">
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>From</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconMail stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    value={emailData.from_email}
                    disabled
                    onChange={(e) =>
                      setEmailData({ ...emailData, from_email: e.target.value })
                    }
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>To</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    <IconMail stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    value={emailData.to_email}
                    onChange={(e) =>
                      setEmailData({ ...emailData, to_email: e.target.value })
                    }
                  />
                </InputGroup>
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Add other emails to CC</Form.Label>
                <Select
                  onChange={(selectedOptions) => {
                    const newCC = [
                      "quotesandsales@aspettoinc.com",
                      ...selectedOptions.map((option) => option.value),
                    ];
                    setEmailData({ ...emailData, cc: newCC });
                  }}
                  defaultValue={
                    emailData.cc
                      ? [
                          ...emailData.cc.map((email) => ({
                            label: email,
                            value: email,
                          })),
                        ]
                      : []
                  }
                  isMulti
                  name="cc"
                  options={
                    EmailUSerData &&
                    EmailUSerData?.data?.map((user) => ({
                      label: user.email,
                      value: user.email,
                    }))
                  }
                  className="basic-multi-select"
                  classNamePrefix="select"
                />
              </Form.Group>
            </Col>

            <Col md={12}>
              <Form.Group className="mb-3">
                <Form.Label>Subject</Form.Label>
                <InputGroup>
                  <InputGroup.Text>
                    {" "}
                    <IconMessageForward stroke={1} />
                  </InputGroup.Text>
                  <Form.Control
                    value={emailData.subject}
                    onChange={(e) =>
                      setEmailData({ ...emailData, subject: e.target.value })
                    }
                  />
                </InputGroup>
              </Form.Group>
            </Col>
            <Col md={12}>
              <ReactQuill
                className="mb-3"
                theme="snow"
                value={emailData.body}
                onChange={(value) =>
                  setEmailData({ ...emailData, body: value })
                }
                placeholder="Body"
              />
            </Col>
          </Row>

          <Row>
            <Col md={12}>
              <div className="bs-stepper-header stepper_komail mb-3">
                <div class="formrow">
                  <input
                    class="checkbox"
                    type="checkbox"
                    id="Attachment"
                    checked={attachFilesChecked}
                    onChange={(e) => {
                      setAttachFilesChecked(e.target.checked);
                      setEmailData({
                        ...emailData,
                        is_attach: e.target.checked,
                      });
                    }}
                  />
                  <label htmlFor="Attachment" class="checklabel step-trigger">
                    Attach Files
                  </label>
                </div>
                <div class="formrow">
                  <input
                    class="checkbox"
                    type="checkbox"
                    id="SKU Details"
                    checked={attachSKUDetailsInTheBody}
                    onChange={async (e) => {
                      handleAttachSKUDetailsCheckboxChange(e);
                      handleAttachSKUDetailsInTheEMailBody(e);
                    }}
                  />
                  <label htmlFor="SKU Details" class="checklabel step-trigger">
                    SKU Details
                  </label>
                </div>
              </div>

              {attachFilesChecked && (
                <>
                  <div className="mb-3">
                    <label className="form-label" htmlFor="attachment-input">
                      Upload Attach File
                    </label>
                    <div className="input-group">
                      <input
                        className="form-control custom-file-input"
                        accept="image/*, .pdf, .doc, .docx"
                        id="attachment-input"
                        multiple
                        type="file"
                        onChange={handleAttachmentChange}
                      />

                      <span className="select_count">
                        {attachments.length === 0
                          ? "No File Chosen"
                          : attachments.length === 1
                          ? `${attachments.length} File`
                          : `${attachments.length} Files`}
                      </span>
                    </div>
                  </div>
                  {attachments.length > 0 ? (
                    <ListGroup className="mb-3">
                      {attachments.map((file, index) => (
                        <ListGroup.Item key={index}>
                          {file.name}
                          <span
                            className="trash_files text-danger"
                            onClick={() => removeAttachment(index)}
                          >
                            <IconTrash />
                          </span>
                        </ListGroup.Item>
                      ))}
                    </ListGroup>
                  ) : null}
                </>
              )}
            </Col>

            {attachSKUDetailsInTheBody && (
              <Col md={12}>
                <div className="mail_wrapper p-0 border-0">
                  <div className="table-responsive">
                    <Table bordered>
                      <thead>
                        <tr>
                          <th> Vendor/Partner</th>
                          <th> SKU ID</th>
                          <th> SKU Desc</th>
                          <th> QTY</th>
                          <th> Unit Cost($)</th>
                          <th> Total Cost($)</th>
                        </tr>
                      </thead>
                      <tbody>
                        {Array.isArray(emailData.sku_data) &&
                          emailData.sku_data.map((P, index) => (
                            <tr key={index}>
                              <td>{P?.Vendor?.display_name}</td>
                              <td>{P?.name ?? P?.Product?.name}</td>
                              <td>{P.description}</td>
                              <td>{trimTrailingZeros(P.quantity)}</td>
                              <td>
                                {Number(P.customer_price).toLocaleString(
                                  "en-US",
                                  {
                                    minimumFractionDigits: 2,
                                    maximumFractionDigits: 2,
                                  }
                                )}
                              </td>
                              <td>
                                {Number(P.total_price).toLocaleString("en-US", {
                                  minimumFractionDigits: 2,
                                  maximumFractionDigits: 2,
                                })}
                              </td>
                            </tr>
                          ))}
                        <tr>
                          <td colSpan={4}></td>
                          <td>
                            {" "}
                            <strong>SUB TOTAL</strong>{" "}
                          </td>
                          <td>
                            <strong> {allSKUsCost}</strong>{" "}
                          </td>
                        </tr>
                      </tbody>
                    </Table>
                  </div>
                </div>
              </Col>
            )}
          </Row>

          <Row>
            <Col md={12}>
              <ReactQuill
                className="mb-3"
                theme="snow"
                value={emailData.signature}
                onChange={(value) =>
                  setEmailData((prevData) => ({
                    ...prevData,
                    signature: value,
                  }))
                }
                placeholder="Signature"
              />
            </Col>
          </Row>
          <Row className="justify-content-center">
            <Col md={3}>
              <Button variant="warning" type="submit" className="w-100">
                {sendLoading ? (
                  <Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  />
                ) : (
                  "Submit"
                )}
              </Button>
            </Col>
          </Row>
        </Form>
      </Modal.Body>
    </Modal>
  );
}

export default KOorCustomerEmailDialog;
